<div class="container-buttons flex w-full flex-row">
  <ion-button [disabled]="!files.length" (click)="buttonClicked.emit('settings')" [class.disabled]="isLoading">
    <div class="flex flex-row items-center justify-center">
      <ion-icon icon="assets/icon/settings-3.svg"></ion-icon>
      <ion-label>Configurar</ion-label>
    </div>
  </ion-button>
  <ion-button (click)="buttonClicked.emit('groups')">
    <div class="flex flex-row items-center justify-center">
      <ion-label>Mis carpetas</ion-label>
      <ion-icon icon="assets/icon/flechaDerecha.svg"></ion-icon>
    </div>
  </ion-button>
</div>
